import React, { FC, useCallback } from "react";
import { Avatar, AvatarProps, Tooltip, TooltipProps } from "antd";
import { User } from "../../graphql/types";
import { colorFromUuid } from "../../util/colorFromUuid";
import { useNavigateToProfile } from "../../util/navigation";
import { eatClick } from "../../util/eatClick";
import { UserOutlined } from "@ant-design/icons";

interface Props extends AvatarProps {
  user: User;
  linkToProfile?: boolean;
  tooltip?: Partial<TooltipProps>;
}

export const UserAvatar: FC<Props> = ({
  user,
  linkToProfile,
  tooltip,
  className = "",
  ...otherProps
}) => {
  const navigateToProfile = useNavigateToProfile();
  const handleClick = useCallback(
    (event) => {
      eatClick(event);
      navigateToProfile(user);
    },
    [user, navigateToProfile]
  );

  return (
    <Tooltip title={user.username} placement="top" {...tooltip}>
      <Avatar
        src={user.imageUrl}
        style={{
          backgroundColor: !user.imageUrl ? colorFromUuid(user.id) : undefined,
          cursor: linkToProfile ? "pointer" : undefined,
          ...otherProps.style,
        }}
        icon={user.username?.[0]?.toUpperCase() ?? <UserOutlined />}
        // @ts-ignore
        onClick={linkToProfile ? handleClick : undefined}
        {...otherProps}
        className={`bg-component ${className}`}
      />
    </Tooltip>
  );
};
